<template>
    <div id="app">
        <router-view />
        <Toast />
    </div>
</template>
<script>
import _ from "lodash";
export default {
  mounted() {
      this.$root.$on("doCopy", function (data) {
      let that = this;     
      let formId=_.clone(data.id).trim();
      let applicationId=_.clone(data.applicationId).trim();
     // Request URL: https://localhost:44315/api/PublishedForms/get-form?appicationid=5f919cd058537fa0100f4528&formid=5fb7e3de0f382a8dd2316003
     let href_url = process.env.VUE_APP_baseUrl +`PublishedForms/get-form?appicationid=${applicationId}&formid=${formId}`;
        this.$copyText(href_url).then(function () {
           that.$toast.add({
              severity: "success",
              //summary : "Form Path Copied",
              detail: "Form Path Copied",
              life: 1500,
            });
        }, function (e) {
          alert('Can not copy' +e.text)
        })
      });      
    }
}
</script>

<style lang="scss">
//@import"../node_modules/bootswatch/dist/yeti/bootswatch.scss";
    @import "./App.scss";
</style>
